import React, { ReactNode, useEffect, useRef, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import styles from "./index.less";
import Breadcrumb, { IBreadcrumbItem } from "../Breadcrumb";
import { setNewsLike, setActivityLike, companyDetailLike } from "@/services/service";
import { MTools } from "..";
import { imagePrefix } from '@/constants';


import good from "@/assets/image/good.png";
import shareImg from "@/assets/image/share.png";
import first from "@/assets/image/first.png";

interface ILayoutProps {
  children: ReactNode;
  padding?: number;
  breadcrumb?: IBreadcrumbItem[];
  share?: boolean;
  businessType?: number;
  businessId?: string | null;
  shareStyle?: React.CSSProperties;
}
const Layout: React.FC<ILayoutProps> = ({
  children,
  padding = 12,
  breadcrumb = [],
  share = false,
  businessType = 0,   // 1: 新闻  2: 活动
  businessId = "",
  shareStyle,
}) => {
  const [showAnimate, setShowAnimate] = useState(false);
  const timerRef = useRef<any>();
  const shareTimerRef = useRef<any>();
  const [visible, setVisible] = useState(false)


  useEffect(() => {
    if (share) {
      return () => {
        clearTimeout(timerRef.current);
        clearTimeout(shareTimerRef.current);
      };
    }
  }, []);

  const showShare = () => {
    setVisible(true)
    if (visible) return
    shareTimerRef.current = setTimeout(() => {
      setVisible(false)
    }, 2000)
  }

  const addLike = async () => {
    if (showAnimate) return;
    setShowAnimate(true);
    timerRef.current = setTimeout(() => {
      setShowAnimate(false);
    }, 1500);
    console.log(businessType)
    if(businessType === 1){ // 新闻点赞
      const result = await setNewsLike(businessId);
      if (!result.success) {
        MTools.Tips(
          "error",
          (result && result.message) || "系统异常，请刷新再试"
        );
      }
    } else if(businessType === 2){ // 活动点赞
      const result = await setActivityLike(businessId);
      if (!result.success) {
        MTools.Tips(
          "error",
          (result && result.message) || "系统异常，请刷新再试"
        );
      }
    } else if (businessType === 3) { // 展位详情点赞
      const result = await companyDetailLike(businessId);
      if (!result.success) {
        MTools.Tips(
          "error",
          (result && result.message) || "系统异常，请刷新再试"
        );
      }
    } else {
      console.warn('businessType为空！！！')
    }
  };

  const onscrollTop = () => {
    document
      ?.getElementById("layoutWrap")
      ?.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={styles.layout}
      style={share ? { paddingBottom: "147px" } : { paddingBottom: "101px" }}
    >
      <div className={styles.header}>
        <Header></Header>
      </div>
      <div
        className={styles.content}
        style={{
          paddingLeft: `${padding}px`,
          paddingRight: `${padding}px`,
        }}
      >
        {children}
      </div>
      <div className={styles.footer}>
        {share && (
          <div className={styles.share} style={{
            paddingRight: padding - 8 > 0 ? padding - 8 : 0,
            ...shareStyle,
          }}>
            <div className={styles.share_left}>
              <div onClick={showShare}>
                <img src={shareImg} alt="" />
              </div>
              <div className={styles.like} onClick={addLike}>
                <div className={showAnimate ? styles.addAnimate : styles.add}>+1</div>
                <img className={showAnimate ? styles.likeAnimate : ""} src={good} alt="" />
              </div>
            </div>
            <div onClick={() => onscrollTop()}>
              <img className={styles.share_right} src={first} alt="" />
            </div>
          </div>
        )}
        <Footer />
      </div>
      {visible && <div
        className={styles.shareContent}>
        <img src={imagePrefix('share-tip.png')} alt="" />
      </div>}
    </div>
  );
};

export default Layout;
